// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1687":"7dc5b298ab98b819","4044":"ffbeab282327b04b"}[chunkId] + ".css";
};